import { EmailAuthProvider, reauthenticateWithCredential } from "firebase/auth";
import { auth } from "../config/firebase";

/** A successful password check covers sensitive actions for this long. */
export const REAUTH_WINDOW_MS = 5 * 60 * 1000;

const KEY = "fd_reauth_at";

export function recentlyReauthenticated(now = Date.now()) {
  try {
    const at = Number(sessionStorage.getItem(KEY));
    const uid = sessionStorage.getItem(`${KEY}_uid`);
    return uid === auth?.currentUser?.uid && Number.isFinite(at) && now - at < REAUTH_WINDOW_MS;
  } catch {
    return false;
  }
}

export function clearReauth() {
  try {
    sessionStorage.removeItem(KEY);
    sessionStorage.removeItem(`${KEY}_uid`);
  } catch {
    /* ignore */
  }
}

export async function reauthenticateWithPassword(password) {
  const current = auth?.currentUser;
  if (!current?.email) throw Object.assign(new Error("NOT_SIGNED_IN"), { code: "auth/no-current-user" });
  await reauthenticateWithCredential(current, EmailAuthProvider.credential(current.email, password));
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
    sessionStorage.setItem(`${KEY}_uid`, current.uid);
  } catch {
    /* the check still succeeded for this call */
  }
}
